<template>
    <div>
        <div v-if="userPersonality && user">

            <h1 class="personality-section--summary__title">{{ $t("discover-the-profile-of-x", {x: capitalize(user.fname)}) }}</h1>

            <spyscroller :sections="sections" />

            <!-- Section Summary -->
            <!-- <div
                id="section-summary"
                class="personality-section personality-section--summary-who-are-you personality-section--summary">
                <div>
                    <ul
                        id=""
                        class="personality-section__anchor-list"
                        :class="(isAStar) ? 'personality-section__anchor-list--10' : 'personality-section__anchor-list--9'">
                        <li
                            v-for="(item, index) in sections"
                            :key="`section-personality-${index}`"
                            v-if="item.visibleOnSummary"
                            class="personality-section__anchor-list-item">
                            <button
                                type="button"
                                class="button button--transparent circle-anchor"
                                @click="jumpToId(`section-${item.name}`)">
                                {{ $t(item.name) }}
                            </button>
                        </li>
                    </ul>

                    <div class="personality-section__artwork-gender">
                        <template v-if="user.gender === 'M'">
                            <img
                                width="85"
                                height="153"
                                src="@/assets/images/artworks/who-i-am/man-plain.svg"
                                :alt="$t('man')" />
                        </template>
                        <template v-else>
                            <img
                                width="85"
                                height="153"
                                src="@/assets/images/artworks/who-i-am/woman-plain.svg"
                                :alt="$t('woman')" />
                        </template>
                        <div
                            class="vertical-sep vertical-sep--summary"
                            :style="{
                                height: `${summaryArtworkVerticalSepHeight}px`,
                                top: `${summaryArtworkVerticalTop}%`
                            }"
                        ></div>
                    </div>
                </div>
                <img
                    class="personality-section__artwork-mouse"
                    width="27"
                    height="62"
                    src="@/assets/images/artworks/who-i-am/mouse-down.svg"
                    alt="" />
            </div> -->

            <!-- Section Culture -->
            <personality-culture
                v-if="userCulture && isAStar"
                :data="userCulture" />

            <!-- Section Domains -->
            <personality-domains :data="userDomains" />

            <!-- Section PlanetHouse -->
            <personality-planet-house :data="userPlanetHouse" />

            <!-- Section House -->
            <personality-house :data="userHouse" />

            <!-- Section Power -->
            <!--  <personality-power :data="userPower" /> -->

            <!-- Section Power2 -->
            <!--   <personality-power2 :data="userPower2" /> -->

            <!-- Section Love -->
            <!--  <personality-love :data="userLove" /> -->

            <!-- Section Love Relationship-->

            <personality-relationship
                v-if="userLoveRelationship"
                :data="userLoveRelationship"
                type="other"
                :user="user"
                class="personality-section--fluid" />

            <!-- Section Career -->
            <personality-career :data="userCareer" />

            <!-- Section Elements -->
            <personality-elements
                v-if="userElements"
                :data="userElements"
                type="other"
                :user="user"
                class="personality-section--fluid" />

            <!-- Sections Polarity -->
            <personality-polarity
                v-if="userPolarity"
                :data="userPolarity"
                type="other"
                :user="user"
                class="personality-section--fluid" />

            <!-- Sections Autonomy -->
            <personality-autonomy
                v-if="userAutonomy"
                :data="userAutonomy"
                :gender="user.gender"
                :user="user"
                type="other"
                class="personality-section--fluid" />

            <!-- Sections Extraversion -->
            <personality-extraversion
                v-if="userExtraversion"
                :data="userExtraversion"
                :gender="user.gender"
                :user="user"
                type="other"
                class="personality-section--fluid" />

            <!-- Sections Modality -->
            <personality-modality
                v-if="userModality"
                :data="userModality"
                :gender="user.gender"
                :user="user"
                type="other"
                class="personality-section--fluid" />

            <!-- Sections Extraversion -->
            <!--          <template v-if="loggedUser.userpremium">
                <personality-skills
                    v-if="userSkills"
                    :data="userSkills"
                    @open-section-help="openSectionHelpModal" />
            </template>
            <template v-else>
                <div
                    id="section-skills"
                    class="personality-section">
                    <div class="vertical-sep vertical-sep--top"></div>

                    <h2 class="personality-section__title">{{ $t("your-aptitudes-for-seeking-your-proffessional-way") }}</h2>

                    <div class="personality-section__content">
                        <placeholder-premium-only/>
                    </div>


                    <div class="vertical-sep vertical-sep--bottom"></div>
                </div>
           
            </template>
 -->

            <personality-skills
                v-if="userSkills"
                :data="userSkills" />

            <!-- Sections Extraversion -->
            <personality-facets
                v-if="userFacets"
                :data="userFacets"
                @open-trait="openMobileBubbleModal"
                @open-trait-detail="openTraitDetailModal" />

            <!-- Sections Romance -->
            <personality-romance
                v-if="userRomance"
                :data="userRomance"
                @open-trait-detail="openTraitDetailModal" />

            <div
                id="section-outro"
                class="personality-section personality-section--outro">
                <div class="vertical-sep vertical-sep--top"></div>

                <h2 class="personality-section__title">{{ $t("compare-with-other") }}</h2>

                <div class="personality-section__content">
                    <ul class="buttons-list buttons-list--centered">
                        <li class="buttons-list__item">
                            <button
                                type="button"
                                @click="$emit('reset-partner')"
                                class="button button--primary">
                                <span class="button__label">{{ $t("change-profile") }}</span>
                            </button>
                        </li>
                        <li
                            v-if="id !== loggedUser.id_person"
                            class="buttons-list__item">
                            <button
                                @click="$emit('show-logged-user-profile')"
                                class="button button--secondary">
                                {{ $t("go-to-my-profile") }}
                            </button>
                        </li>
                    </ul>
                </div>
            </div>

            <personality-section-know-more-modal
                v-if="isSectionHelpModalVisible"
                :data="currentKnowMoreModalData"
                @closeModal="closeSectionHelpModal"></personality-section-know-more-modal>

            <trait-detail-modal
                v-if="istraitModalVisible"
                :current-trait-detail="currentTraitModalData"
                :display-score="displayScore"
                @closeModal="closeTraitDetailModal"
                :current-user-score="currentUserScore">
            </trait-detail-modal>


            <transition name="bubble-modal">
                <bubble-mobile-modal
                    v-if="isMobileBubbleModalOpen"
                    :data="currentBubble"
                    @closeModal="closeMobileBubbleModal"></bubble-mobile-modal>
            </transition>
        </div>
        <div v-else>
            <div
                class="loader">
                <HorizontalBubbleLoader />
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

import Spyscroller from "@/components/spyscroller/Spyscroller.vue";
import HorizontalBubbleLoader from "@/components/loaders/HorizontalBubbleLoader.vue";

import PersonalityDomains from "@/components/personality/sections/PersonalityDomains.vue";
import PersonalityElements from "@/components/personality/sections/PersonalityElements.vue";
import PersonalityPolarity from "@/components/personality/sections/PersonalityPolarity.vue";
import PersonalityAutonomy from "@/components/personality/sections/PersonalityAutonomy.vue";
import PersonalityExtraversion from "@/components/personality/sections/PersonalityExtraversion.vue";
import PersonalityModality from "@/components/personality/sections/PersonalityModality.vue";
import PersonalitySkills from "@/components/personality/sections/PersonalitySkills.vue";
import PersonalityFacets from "@/components/personality/sections/PersonalityFacets.vue";
import PersonalityRomance from "@/components/personality/sections/PersonalityRomance.vue";
import PersonalityCulture from "@/components/personality/sections/PersonalityCulture.vue";
import PersonalityHouse from "@/components/personality/sections/PersonalityHouse.vue";
import PersonalityPlanetHouse from "@/components/personality/sections/PersonalityPlanetHouse.vue";
//import PersonalityPower from "@/components/personality/sections/PersonalityPower.vue";
//import PersonalityPower2 from "@/components/personality/sections/PersonalityPower2.vue";
//import PersonalityLove from "@/components/personality/sections/PersonalityLove.vue";
import PersonalityRelationship from "@/components/personality/sections/PersonalityRelationship.vue";
import PersonalityCareer from "@/components/personality/sections/PersonalityCareer.vue";

import PersonalitySectionKnowMoreModal from "@/components/modals/personality/PersonalitySectionKnowMoreModal.vue";
import TraitDetailModal from "@/components/modals/traits/TraitDetailModal.vue";
import BubbleMobileModal from "@/components/modals/BubbleMobileModal.vue";

import { getMe, getUserInfo } from "@/utils/api/usersApi.js";

//import PlaceholderPremiumOnly from "@/components/placeholder/PlaceholderPremiumOnly.vue";

export default {
    name: "WhoAreYou",
    components: {
        HorizontalBubbleLoader: HorizontalBubbleLoader,
        TraitDetailModal: TraitDetailModal,
        PersonalitySectionKnowMoreModal: PersonalitySectionKnowMoreModal,
        Spyscroller: Spyscroller,
        PersonalityDomains: PersonalityDomains,
        PersonalityElements: PersonalityElements,
        PersonalityPolarity: PersonalityPolarity,
        PersonalityAutonomy: PersonalityAutonomy,
        PersonalityExtraversion: PersonalityExtraversion,
        PersonalityModality: PersonalityModality,
        PersonalitySkills: PersonalitySkills,
        PersonalityFacets: PersonalityFacets,
        PersonalityRomance: PersonalityRomance,
        PersonalityCulture: PersonalityCulture,
        PersonalityHouse : PersonalityHouse,
        PersonalityPlanetHouse : PersonalityPlanetHouse,
        // PersonalityPower : PersonalityPower,
        //PersonalityPower2 : PersonalityPower2,
        //PersonalityLove : PersonalityLove,
        PersonalityRelationship : PersonalityRelationship,
        PersonalityCareer : PersonalityCareer,
        BubbleMobileModal: BubbleMobileModal, 

        //PlaceholderPremiumOnly: PlaceholderPremiumOnly
    },
    props: {
        id: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            userPersonality: null,
            user: null,
            isMobile: true,
            isXSmall: true,
            isMobileBubbleModalOpen: false,
            currentBubble: {},
            currentUserScore: 0,
            displayScore: "",
            currentTrait: "",
            traitsData: "",
            currentTraitModalData: "",
            istraitModalVisible: false,
            knowMoreData: "",
            currentKnowMoreModalData: "",
            isSectionHelpModalVisible: false,
            viewPortHeight: window.innerHeight,
            sections: [
                /*{
                    "name": "summary",
                    "visibleOnSummary": false
                },*/
                {
                    "name": "domains",
                    "visibleOnSummary": true
                },
                {
                    "name": "house",
                    "visibleOnSummary": true
                },
                {
                    "name": "placement",
                    "visibleOnSummary": true
                },
                {
                    "name": "love",
                    "visibleOnSummary": true
                },
                {
                    "name": "relationship",
                    "visibleOnSummary": true
                },
                {
                    "name": "career",
                    "visibleOnSummary": true
                },
                {
                    "name": "elements",
                    "visibleOnSummary": true
                },
                {
                    "name": "polarity",
                    "visibleOnSummary": true
                },
                {
                    "name": "autonomy",
                    "visibleOnSummary": true
                },
                {
                    "name": "extraversion",
                    "visibleOnSummary": true
                },
                {
                    "name": "modality",
                    "visibleOnSummary": true
                },
                {
                    "name": "skills",
                    "visibleOnSummary": true
                },
                {
                    "name": "facets",
                    "visibleOnSummary": true
                },
                {
                    "name": "romance",
                    "visibleOnSummary": true
                },
                {
                    "name": "outro",
                    "visibleOnSummary": false
                }
            ],
        };
    },
    computed: {
        // user
        // Current logged user
        loggedUser() {
            return this.$store.getters["userModule/getUser"];
        },
        isAStar() {
            if (this.user && !this.user.login) {
                return true;
            }

            return false;
        },
        userDomains() {
            if (this.userPersonality) {
                const domains = this.userPersonality.filter((item) => {
                    return (item.category === "Base");
                });

                return domains;
            }

            return;
        },
        userHouse() {
            if (this.userPersonality) {
                const domains = this.userPersonality.filter((item) => {
                    return (item.category === "house");
                });

                return domains;
            }

            return;
        },
        userPlanetHouse() {
            if (this.userPersonality) {
                const domains = this.userPersonality.filter((item) => {
                    return (item.category === "planethouse");
                });

                return domains;
            }

            return;
        },
        /*userPower() {
            if (this.userPersonality) {
                const domains = this.userPersonality.filter((item) => {
                    return (item.category === "power1");
                });

                return domains;
            }

            return;
        },
        /*userPower2() {*/
        /*            if (this.userPersonality) {*/
        /*                const domains = this.userPersonality.filter((item) => {*/
        /*                    return (item.category === "power2");*/
        /*                });*/
        /**/
        /*                return domains;*/
        /*            }*/
        /**/
        /*            return;*/
        /*        },*/
        userLove() {
            if (this.userPersonality) {
                const domains = this.userPersonality.filter((item) => {
                    return (item.category === "love");
                });

                return domains;
            }

            return;
        },
        userLoveRelationship() {
            if (this.userPersonality) {
                const domains = this.userPersonality.filter((item) => {
                    return (item.type === "QQ" && item.category === "love_element");
                });

                return domains;
            }

            return;
        },
        userCareer() {
            if (this.userPersonality) {
                const domains = this.userPersonality.filter((item) => {
                    return (item.category === "career");
                });

                return domains;
            }

            return;
        },
        userPolarity() {
            if (this.userPersonality) {
                const polarity = this.userPersonality.filter((item) => {
                    return (item.type === "QQ" && item.category === "Gender");
                });

                return polarity;
            }

            return;
        },
        userElements() {
            if (this.userPersonality) {
                const elements = this.userPersonality.filter((item) => {
                    return (item.type === "QQ" && item.category === "Temperament");
                });

                return elements;
            }

            return;
        },
        userAutonomy() {
            if (this.userPersonality) {
                const autonomy = this.userPersonality.filter((item) => {
                    return (item.type === "QQ" && item.category === "Secteur");
                });

                return autonomy;
            }

            return;
        },
        userExtraversion() {
            if (this.userPersonality) {
                const extraversion = this.userPersonality.filter((item) => {
                    return (item.type === "QQ" && item.category === "SecteurDay");
                });

                return extraversion;
            }

            return;
        },
        userModality() {
            if (this.userPersonality) {
                const modality = this.userPersonality.filter((item) => {
                    return (item.type === "QQ" && item.category === "Ternaire");
                });

                return modality;
            }

            return;
        },
        userSkills() {
            if (this.userPersonality) {
                const skills = this.userPersonality.filter((item) => {
                    return (item.category === "Metier");
                });

                return skills;
            }

            return;
        },
        userFacets() {
            if (this.userPersonality) {
                const facets = this.userPersonality.filter((item) => {
                    return (item.category === "Perso");
                });

                return facets;
            }

            return;
        },
        userRomance() {
            if (this.userPersonality) {
                const romances = this.userPersonality.filter((item) => {
                    return (item.category === "Love");
                });

                return romances;
            }

            return;
        },
        userCulture() {
            if (this.userPersonality) {
                const cultures = this.userPersonality.filter((item) => {
                    return (item.category === "culture");
                });

                return cultures;
            }

            return;
        },
        summaryArtworkVerticalSepHeight() {
            if (this.isAStar) {
                if (!this.isMobile) {
                    return (this.viewPortHeight / 2) - 350 - 130;
                }

                return (this.viewPortHeight / 2) - 225;
            } else {
                if (!this.isMobile) {
                    return (this.viewPortHeight / 2) - 350;
                }

                return (this.viewPortHeight / 2) - 225;
            }
        },
        summaryArtworkVerticalTop() {
            if (this.isAStar) {

                if (this.isMobile) {
                    return 100;
                }

                return 160;
            } else {
                return 100;
            }
        }
    },
    watch: {
        id(val, oldVal) {
            if (val !== oldVal) {

                this.userPersonality = null;
                this.user = null;

                this.fetchUserPersonality();
                this.fetchUserInfo();
            }
        },
        isAStar(val) {
            if (val === true) {
                this.sections.splice(1, 0, {
                    "name": "bio",
                    "visibleOnSummary": true
                });
            }
        }
    },
    mounted() {
        // Responsive Behavior
        /* istanbul ignore next */
        this.$responsive.registerMediaQuery("from-desktop", () => {
            this.isMobile = false;
        }, () => {
            this.isMobile = true;
        });

        this.$responsive.registerMediaQuery("from-small", () => {
            this.isXSmall = false;
        }, () => {
            this.isXSmall = true;
        });

        this.getWiewportHeight();
        window.addEventListener("resize", this.getWiewportHeight);

        this.fetchUserPersonality();
        this.fetchUserInfo();

        this.fetchKnowMoreData();
        this.fetchTraitDetailData();
    },
    destroyed() {
        document.removeEventListener("resize", this.getWiewportHeight);
    },
    methods: {
        fetchKnowMoreData () {
            const currentLocal = this.$i18n.locale;

            axios({
                url: `/json/personality/personality-know-more-content.${currentLocal}.json`,
            }).then(res => {
                this.knowMoreData = res.data;
            }).catch(e => {
                if (e.response) {
                    throw e.response;
                }
            });
        },
        fetchTraitDetailData () {
            const currentLocal = this.$i18n.locale;

            axios({
                url: `/json/traits/traits-detail.${currentLocal}.json`,
            }).then(res => {
                this.traitsData = res.data;
            }).catch(e => {
                if (e.response) {
                    throw e.response;
                }
            });
        },
        openSectionHelpModal(section) {
            this.currentKnowMoreModalData = this.knowMoreData[section];
            this.isSectionHelpModalVisible = true;
        },
        closeSectionHelpModal() {
            this.isSectionHelpModalVisible = false;
        },
        openTraitDetailModal(trait, value) {
            this.currentUserScore = value;
            this.displayScore = value;

            this.currentTraitModalData = this.traitsData[trait];

            if (this.traitsData[trait]) {
                this.istraitModalVisible = true;
            }
        },
        closeTraitDetailModal() {
            this.istraitModalVisible = false;
        },
        updateCurrentCategory(type) {
            this.currentCategory = type;
        },
        getWiewportHeight() {
            this.viewPortHeight = window.innerHeight;
        },
        openMobileBubbleModal(bubble) {
            // if (this.isMobile) {
            //     this.currentBubble = bubble;
            //     this.isMobileBubbleModalOpen = true;
            // }
        },
        closeMobileBubbleModal() {
            // this.currentBubble = {};
            // this.isMobileBubbleModalOpen = false;
        },
        fetchUserPersonality() {
            const user = {
                id: this.id,
                id_user: this.loggedUser.id_person,
            };

            getMe(user).then((res) => {
                if (res.status === 200 && res.data) {

                    this.userPersonality =  res.data.part1;
                } else {
                    // Handle Error
                    let message = this.$t("a-server-error-occured-please-try-later");
                    this.$notificationsBar.alert(message, {type: "warning"});
                }
            });
        },
        fetchUserInfo() {
            const user = {
                id: this.id
            };

            getUserInfo(user).then((res) => {
                if (res.status === 200 && res.data) {
                    this.user =  res.data;
                } else {
                    // Handle Error
                    let message = this.$t("a-server-error-occured-please-try-later");
                    this.$notificationsBar.alert(message, {type: "warning"});
                }
            });
        }
    }
};
</script>

